import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ManabuaFeaturedVideos',
  setup(__props) {

const isProd = process.env.VUE_APP_ENVIRONMENT === 'production';
const staging = [
  { label: 'Sweden', id: '6HqxAZtDU3LF1L2N9S8Wp' },
  { label: 'Norway', id: '0HZvKp2M0RvHHQfKJOzVg' },
  { label: 'Finland', id: 'N3A9jV30FQ06K9U4TPZHc' },
];
const prod = [
  { label: 'Sweden', id: 'UfhDLH2QhXH0DSA2gHJCY' },
  { label: 'Norway', id: 'Bchvi8JN4iBzTWRjE59vw' },
  { label: 'Finland', id: 'RFATUVA0QRCUhlW6BIE4A' },
];
const items = computed(() => (isProd ? prod : staging));

return { __sfc: true,isProd, staging, prod, items }
}

})